import { createFileRoute } from '@tanstack/react-router'
import { ResetCredentialsRequest } from "@/components/credentials-reset";

export const Route = createFileRoute('/credential-reset-request')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ResetCredentialsRequest/>
}
